import { Select } from 'antd'
import styled from 'styled-components'

export const StyledDamageSelect = styled(Select)`
  width: 100%;

  .ant-select-selector {
    background-color: #000000 !important;
    border-color: #666666 !important;
    color: white !important;
    min-height: 40px;
    height: auto !important;
  }

  .ant-select-selection-placeholder {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  .ant-select-selection-item {
    color: white !important;
    background-color: #2e7d32 !important;
    border-color: #4caf50 !important;
  }

  .ant-select-selection-item-remove {
    color: rgba(255, 255, 255, 0.8) !important;
  }

  .ant-select-arrow {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  .ant-select-clear {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  &:hover .ant-select-selector {
    border-color: #888888 !important;
  }

  &.ant-select-focused .ant-select-selector {
    border-color: #4caf50 !important;
    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2) !important;
  }

  /* Dropdown styles */
  .ant-select-dropdown {
    background-color: #1a1a1a !important;
    border: 1px solid #666666 !important;
  }

  .ant-select-item {
    background-color: #1a1a1a !important;
    color: white !important;
  }

  .ant-select-item-option-selected {
    background-color: #2e7d32 !important;
    color: white !important;
  }

  .ant-select-item:hover {
    background-color: #444444 !important;
  }
`
